import { createEvent, createStore, restore, sample } from "effector";
import { ModelContract, ModuleDescription } from "@features/shared/module-description";
import { $currentOnboardingStep, nextStep, prevStep } from "@features/onboarding/ui/passingTheOnboarding";
import { onboardingData } from "@data/onboarding";

export const appMounted = createEvent();
export const routePathNameChanged = createEvent<string>();
export const onboardingProgressUpdated = createEvent<number>();
export const $activeRoute = restore(routePathNameChanged, "/");

export const $isOnboarding = createStore<boolean>(false);
export const $onboardingProgress = createStore<number>(0);

sample({
    clock: routePathNameChanged,
    fn: (url: string) => {
        const result =
            url === "/" ||
            url === "/payment" ||
            url.startsWith("/onboarding/") ||
            url === "/onboarding" ||
            url === "/auth/signin" ||
            url === "/creator";
        return result;
    },
    target: [$isOnboarding]
});

// sample({
//     clock: [nextStep, prevStep],
//     source: $currentOnboardingStep,
//     fn: (step) => {
//         const calculatedProgress = ((step + 1) / onboardingData.length) * 100;
//         return calculatedProgress;
//     },
//     target: $onboardingProgress,
// })

const contract = new ModelContract(
    {
        $isOnboarding,
        $onboardingProgress
    },
    {
        appMounted,
        onboardingProgressUpdated
    },
    {},
    {}
);

export type IisOnboardingContract = typeof contract;

export class IsOnboardingModule extends ModuleDescription<IisOnboardingContract> {
    getDefaultContract() {
        return contract;
    }
}
